































































































/* tslint:disable:no-console */
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { TableConfig, IDRec, VForm } from '@/interfaces';
import { Getter } from 'vuex-class';
import CommonMixin from '../mixins/CommonMixin';

@Component({
  metaInfo() {
    return {
      title: (this as any).detailTitle
    };
  }
})
export default class DetailLayout extends Mixins(CommonMixin) {
  // Props
  @Prop(Object) public tableCfg!: TableConfig;
  @Prop(String) public id!: string;
  @Prop({ type: Boolean, default: false }) public readonly customSave!: boolean;
  @Prop({ type: Boolean, default: false }) public toOverviewAfterSave!: boolean;
  @Prop({ type: Function, default: null }) public allowInvalidCommit!: () => boolean|null;

  // Variables
  public priv = this.getPrivilege(this.tableCfg);
  public apiUrl = this.formatUrl(this.getTableCfg(this.tableCfg, 'apiUrl'));
  public url = this.formatUrl(this.getTableCfg(this.tableCfg, 'url'));
  public filterName = this.getTableCfg(this.tableCfg, 'filterName');
  public overviewUrl = this.getTableCfg(this.tableCfg, 'overviewUrl')
    ? this.formatUrl(this.getTableCfg(this.tableCfg, 'overviewUrl'))
    : this.url;
  public addRecord =
    this.getTableCfg(this.tableCfg, 'addRecord') !== undefined
      ? this.getTableCfg(this.tableCfg, 'addRecord')
      : true;
  public detailTitle = this.getTableCfg(this.tableCfg, 'detailTitle');
  public deleteTitle = this.getTableCfg(this.tableCfg, 'deleteTitle');
  public newRecord = this.tableCfg.newRecord;
  public forEdit = this.getTableCfg(this.tableCfg, 'forEdit')
    ? this.getTableCfg(this.tableCfg, 'forEdit')
    : false;
  public rec: IDRec = { id: 0 };
  public loading = false;
  public formValid = false;
  public deleteDialogValue = false;

  // Computed
  public get readPrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'read') : true;
  }

  public get writePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'write') : true;
  }

  public get managePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'manage') : true;
  }

  public get editPrivilege() {
    return this.writePrivilege;
  }

  public get isReadOnly() {
    return !this.editPrivilege || (!this.isEdit && !this.isNew);
  }

  public get isEdit() {
    return this.editPrivilege && this.$route.query.mode === 'edit';
  }

  public get hasPrev() {
    if (this.isEdit || this.isNew) {
      return false;
    }
    return this.rec.prev_id !== undefined ? this.rec.prev_id : true;
  }

  public get hasNext() {
    if (this.isEdit || this.isNew) {
      return false;
    }
    return this.rec.next_id !== undefined ? this.rec.next_id : true;
  }

  public get isNew() {
    return this.editPrivilege && this.$route.params.id === 'new';
  }

  public get isSaveDisabled() {
    return this.loading;
  }

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }
  @Getter('getFilterHash')
  public getFilterHash!: (name: string) => string;

  public allowDuplicate(item) {
    if (this.tableCfg.duplicatable) {
      return this.tableCfg.duplicatable;
    } else {
      return false;
    }
  }

  public customEditable(item) {
    if (this.tableCfg.customEditable) {
      return this.tableCfg.customEditable(this, item);
    } else {
      return true;
    }
  }

  public customDeletable(item) {
    if (this.tableCfg.customDeletable) {
      return this.tableCfg.customDeletable(this, item);
    } else {
      return this.tableCfg.deletable;
    }
  }

  public goToPrev() {
    this.$router.push({ path: this.url + '/' + String(this.rec.prev_id), query: this.$route.query});
  }

  public goToNext() {
    this.$router.push({ path: this.url + '/' + String(this.rec.next_id), query: this.$route.query});
  }

  public goToOverview() {
    this.$router.push(this.overviewUrl);
  }

  public async onEdit() {
    if (this.forEdit) {
      this.getForEditRecord(this.rec.id);
    }
    this.$router.push(this.url + '/' + String(this.rec.id) + '?mode=edit');
  }

  public onUndoEdit() {
    if (this.isNew) {
      this.$router.push(this.overviewUrl);
    } else {
      this.$router.push(this.url + '/' + String(this.rec.id));
      this.getRecord();
    }
  }

  public async getForEditRecord(id) {
    this.loading = true;
    const response = await this.api.getRecord(this.$store, this.apiUrl + id, {
      for_edit: 'yes'
    });
    if (response) {
      this.rec = response.data;
      this.$emit('loaded', this.rec);
      this.theForm.resetValidation();
      this.loading = false;
    }
  }
  public onDuplicate() {
    this.$router.push(this.url + '/new?copy=' + String(this.rec.id));
  }

  public async getRecord() {
    if (this.isNew) {
      if (this.$route.query.copy) {
        const id = this.$route.query.copy;
        const response = await this.api.getRecord(this.$store, this.apiUrl + id);

        if (response) {
          this.rec = response.data;
          this.$emit('copyrecord', this.rec);
          if (this.theForm) {
            this.theForm.resetValidation();
          }
          this.loading = false;
        } else {
          this.rec = {id: 0};
        }
      } else if (this.newRecord) {
        // JSON parse and stringify remove the observer so tableCfg.newRecord will not be changed
        this.rec = JSON.parse(JSON.stringify({ ...this.rec, ...this.newRecord }));

        for (const query in this.$route.query) {
          if (query) {
            if (query.includes('id')) {
              this.rec[query] = Number(this.$route.query[query]);
            } else {
              this.rec[query] = this.$route.query[query];
            }
          }
        }
        this.$emit('newrecord', this.rec);
      }
    } else {
      this.loading = true;
      let id = '';
      if (this.id) {
        // Use ID that is given as a prop
        id = this.id;
      } else {
        // Get ID from URL
        id = this.$route.params.id;
      }
      if (this.isEdit && this.forEdit) {
        this.getForEditRecord(id);
      } else {
        const queryObj: any = {};
        const filterHash = this.getFilterHash(this.filterName);
        if (filterHash) {
          queryObj.filter_hash = filterHash;
        }
        const response = await this.api.getRecord(this.$store, this.apiUrl + id, queryObj);
        if (response) {
          this.rec = response.data;
          this.$emit('loaded', this.rec);
          this.theForm.resetValidation();
          this.loading = false;
        }
      }
    }
  }

  public async saveRecord() {
    const rec: IDRec = this.rec;
    if (!this.formValid) {
      this.theForm.validate();
    }
    if (this.formValid || (this.allowInvalidCommit && this.allowInvalidCommit())) {
      this.loading = true;
      if (this.customSave) {
        this.$emit('save', rec, this.apiUrl);
      } else {
        this.commitRecord(rec, true);
      }
    }
  }

  public async commitRecord(rec, skipValidate: boolean = false) {
    if (!this.formValid && !skipValidate) {
      this.theForm.validate();
    } else {
      if (this.isNew) {
        const response = await this.api.createRecord(
          this.$store,
          this.apiUrl,
          rec
        );
        if (response) {
          this.loading = false;
          this.rec = response.data;
          if (this.toOverviewAfterSave) {
            this.goToOverview();
          } else {
            this.$router.push(this.url + '/' + this.rec.id);
          }
        } else {
          this.loading = false;
        }
      } else {
        const response = await this.api.updateRecord(
          this.$store,
          this.apiUrl + rec.id,
          rec
        );
        this.loading = false;
        if (this.toOverviewAfterSave) {
          this.goToOverview();
        } else {
          // Avoid duplicate route error
          const newRoute = this.url + '/' + rec.id;
          console.log('commitRecord, newRoute', newRoute, this.$route.query);
          if (
            this.$route.path !== newRoute ||
            !this.isEmpty(this.$route.query)
          ) {
            this.$router.push(newRoute);
          }
          if (response) {
            console.log('commitRecord, assign rec');
            this.rec = response.data;
          }
        }
      }
    }
  }

  public async deleteRecord() {
    await this.api.deleteRecord(this.$store, this.apiUrl + this.rec.id);
    this.goToOverview();
  }

  // Helper Functions
  public isEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  public formatUrl(url) {
    const re = /\{\w+\}/g;
    return url.replace(re, this.getId);
  }

  public getId(match) {
    const id = match.substring(1, match.length - 1);
    return this.$route.params[id];
  }

  // Lifecycle Functions
  public onCloseWindow(event) {
    // console.log('onCloseWindow', this.isNew, this.isEdit, this.isNew || this.isEdit, event);
    if (this.isNew || this.isEdit) {
        event.preventDefault();
        event.returnValue = '';
    }
  }
  public created() {
    // console.log('created', this);
    window.addEventListener('beforeunload', this.onCloseWindow);
    if (!this.readPrivilege) {
      this.$router.push('/noaccess');
    }
    this.$watch(
      '$route.params.id',
      function(newValue, oldValue) {
          console.log('DetailLayout.$watch $route.params.id', oldValue, '->',  newValue);
          this.getRecord();
        }
    );
  }

  public mounted() {
    // console.log('mounted', this);
    if (this.isNew && !this.addRecord) {
      // Add new record is not allowed
      this.goToOverview();
    }
    this.getRecord();
  }

  public destroyed() {
    // console.log('destroyed', this);
    window.removeEventListener('beforeunload', this.onCloseWindow);
  }

}
